export enum FileUploadStatus {
	UPLOADED = 0,
	PENDING = 1,
	UPLOADING = 2,
	ERROR = 3
}
